import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { CUIHStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUILoginButton from 'connect-dot-com-ui-components/Components/CUILoginButton/CUILoginButton';
import CUISignupButton from 'connect-dot-com-ui-components/Components/CUISignupButton/CUISignupButton';

const LoginSignupButtons = (_ref) => {
  let {
    trackingUrl,
    trackingIdentifier
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["trackingUrl", "trackingIdentifier"]);

  return /*#__PURE__*/_jsxs(CUIHStack, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(CUISignupButton, {
      variant: "primary",
      trackingUrl: trackingUrl,
      trackingIdentifier: trackingIdentifier
    }), /*#__PURE__*/_jsx(CUILoginButton, {
      trackingIdentifier: trackingIdentifier
    })]
  }));
};

export default LoginSignupButtons;